/**
 * User reducer
 *
 * @author Mamontov Andrey, 11/2018
 */
import * as userActions from '../actions/user';
import { AppUser } from '../../models/user.model';
import { UserAction } from '../actions/user';
//
export const getSelected = (state: UserState) => state.selected;
export const getLoading = (state: UserState) => state.loading;
export const getError = (state: UserState) => state.error;

export interface UserState {
  selected: AppUser;
  loading: false;
  error: false;
}

export const initialState: UserState = {
  selected: null,
  loading: false,
  error: false
};

export function reducer (state = initialState, action: UserAction): any {
  switch (action.type) {
    case userActions.USER_LOGIN: {
      localStorage.clear();
      return {
        ...state,
        selected: null,
        loading: true,
      };
    }
    case userActions.USER_LOGOUT: {
      localStorage.clear();
      return {
        ...state,
        selected: null,
        loading: false,
      };
    }
    case userActions.USER_LOGIN_SUCCESS: {
      localStorage.setItem('user', JSON.stringify({ ...action.payload, isLogged: true }));
      return {
        ...state,
        selected: action.payload,
        loading: false,
      };
    }
    case userActions.USER_UPDATE_DATA_SUCCESS:
    case userActions.USER_UPDATE_DATA: {
      return {
        ...state,
        selected: action.payload
      };
    }
    case userActions.USER_LOGIN_FAIL: {
      return {
        ...state,
        selected: null,
        error: action.payload,
        loading: false
      };
    }
    case userActions.USER_UPDATE_DATA_FAIL: {
      return {
        ...state,
        error: action.payload
      };
    }
    default:
      return state;
  }
}
